module.exports = __webpack_public_path__ + "assets/images/pages/medipremium/icon-medipremium-2.png?aea581ae";